export default __webpack_public_path__ + "static/media/pbb.a038413a.png";